// Add custom checkbox markup
export function customCheckbox() {
  if (document.querySelector(".wpcf7")) {
    const acceptanceLabels = document.querySelectorAll(
      ".wpcf7-acceptance label",
    );

    acceptanceLabels.forEach((label) => {
      const span = document.createElement("span");
      span.classList.add("custom-checkbox");
      label.appendChild(span);
    });
  }
}

// Add custom-select class
export function customSelectClass() {
  if (document.querySelector(".wpcf7")) {
    const selectElements = document.querySelectorAll(".wpcf7 select");
    selectElements.forEach((select) => {
      select.parentElement.classList.add("custom-select");
    });
  }
}
